module.exports = __webpack_public_path__ + "img/kommune-831.8ee52db4.svg";